import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import SmoothScroll from './components/SmoothScroll';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import FloatingButtons from './components/home/FloatingButtons';
import DashboardLayout from './components/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import MyOrders from './pages/MyOrders';
import StructuredData from './components/StructuredData';


import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminLogin from './pages/admin/AdminLogin';
import ProductList from './pages/admin/products/ProductList';
import AddProduct from './pages/admin/products/AddProduct';
import EditProduct from './pages/admin/products/EditProduct';
import CategoryManager from './pages/admin/categories/CategoryManager';
import ProductTypeManager from './pages/admin/categories/ProductTypeManager';
import UserManager from './pages/admin/UserManager';
import QueryManager from './pages/admin/QueryManager';
import SEO_Page from './pages/services/SEO';
import DigitalMarketing from './pages/services/DigitalMarketing';
import CustomSoftware from './pages/services/CustomSoftware';
import UiUxDesign from './pages/services/UiUxDesign';
import WebsiteDevelopment from './pages/services/WebsiteDevelopment';
import AndroidDevelopment from './pages/services/AndroidDevelopment';
import ECommerce from './pages/services/ECommerce';
import CloudSolutions from './pages/services/CloudSolutions';
import CyberSecurity from './pages/services/CyberSecurity';
import CodingCourses from './pages/services/CodingCourses';



function App() {

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="bg-[#ffffff] min-h-screen text-[#0f172a] overflow-x-hidden">
        <StructuredData />
        <SmoothScroll>
          <ScrollToTop />
          <Routes>
            {/* Public Routes with Header/Footer */}
            <Route path="/" element={
              <div className="App selection:bg-blue-600 selection:text-white">
                <Header />
                <main><Home /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/about" element={
              <div className="App selection:bg-blue-600 selection:text-white">
                <Header />
                <main><About /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/services" element={
              <div className="App selection:bg-blue-600 selection:text-white">
                <Header />
                <main><Services /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/contact" element={
              <div className="App selection:bg-blue-600 selection:text-white">
                <Header />
                <main><Contact /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/privacy" element={
              <div className="App selection:bg-blue-600 selection:text-white">
                <Header />
                <main><PrivacyPolicy /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/terms" element={
              <div className="App selection:bg-blue-600 selection:text-white">
                <Header />
                <main><TermsAndConditions /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/products" element={
              <div className="App selection:bg-blue-600 selection:text-white">
                <Header />
                <main><Products /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/products/:slug" element={
              <div className="App selection:bg-blue-600 selection:text-white">
                <Header />
                <main><ProductDetail /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/services/seo" element={
              <div className="App selection:bg-blue-600 selection:text-white">
                <Header />
                <main><SEO_Page /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/services/digital-marketing" element={
              <div className="App selection:bg-blue-600 selection:text-white">
                <Header />
                <main><DigitalMarketing /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/services/custom-software" element={
              <div className="App selection:bg-blue-600 selection:text-white">
                <Header />
                <main><CustomSoftware /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/services/ui-ux-design" element={
              <div className="App selection:bg-blue-600 selection:text-white">
                <Header />
                <main><UiUxDesign /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/services/website-development" element={
              <div className="App selection:bg-blue-600 selection:text-white">
                <Header />
                <main><WebsiteDevelopment /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/services/android-development" element={
              <div className="App selection:bg-primary selection:text-white">
                <Header />
                <main><AndroidDevelopment /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/services/ecommerce" element={
              <div className="App selection:bg-primary selection:text-white">
                <Header />
                <main><ECommerce /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/services/cloud-solutions" element={
              <div className="App selection:bg-primary selection:text-white">
                <Header />
                <main><CloudSolutions /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/services/cyber-security" element={
              <div className="App selection:bg-primary selection:text-white">
                <Header />
                <main><CyberSecurity /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />
            <Route path="/services/coding-courses" element={
              <div className="App selection:bg-primary selection:text-white">
                <Header />
                <main><CodingCourses /></main>
                <Footer />
                <FloatingButtons />
              </div>
            } />

            {/* Auth Routes */}
            <Route path="/login" element={
              <div className="App selection:bg-primary selection:text-white">
                <Login />
              </div>
            } />
            <Route path="/register" element={
              <div className="App selection:bg-primary selection:text-white">
                <Register />
              </div>
            } />
            <Route path="/forgot-password" element={
              <div className="App selection:bg-primary selection:text-white">
                <ForgotPassword />
              </div>
            } />

            {/* Dashboard Routes (Protection removed as per request) */}
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="orders" element={<MyOrders />} />
              <Route path="profile" element={<Profile />} />
              <Route path="settings" element={<Settings />} />
            </Route>

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="users" element={<UserManager />} />
              <Route path="products" element={<ProductList />} />
              <Route path="products/add" element={<AddProduct />} />
              <Route path="products/edit/:id" element={<EditProduct />} />
              <Route path="categories" element={<CategoryManager />} />
              <Route path="product-types" element={<ProductTypeManager />} />
              <Route path="queries" element={<QueryManager />} />
              <Route path="projects" element={<div className="text-white font-bold p-8 text-2xl">Project Tracking (Coming Soon)</div>} />
              <Route path="settings" element={<div className="text-white font-bold p-8 text-2xl">System Settings (Coming Soon)</div>} />
            </Route>
          </Routes>
        </SmoothScroll>
      </div>
    </Router>
  );
}

export default App;
